import React from "react";
import styled from "styled-components";
import momentTz from "moment-timezone";
import { useCurrentUserTimezone } from "core/hooks/useCurrentTimeZone";
import { TaskSchedulerMetrics } from "core/queries/GetSchedulerMetrics";
import { cleaningRequestCategoryToLabel } from "schedule/utils/scheduleUtils";

const Grid = styled.div`
  display: grid;
  grid-row-gap: 0.86rem;
  grid-template-columns: 1fr 1fr 1fr;
`;

const Text = styled.div`
  margin-bottom: 0.57rem;
`;

const ValueAndLabel = styled.div`
  display: flex;
`;

const Value = styled.div`
  font-weight: 700;
  margin-right: 0.5rem;
  min-width: 2.14rem;
`;

const Label = styled.label`
  max-width: 6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface CleanTypeMetricsProps {
  startAt: string;
  taskSchedulerMetrics: TaskSchedulerMetrics;
}

export const CleanTypeMetrics = ({
  startAt,
  taskSchedulerMetrics,
}: CleanTypeMetricsProps) => {
  const timezone = useCurrentUserTimezone();
  const { totalCleanTypes } = taskSchedulerMetrics;
  const filteredCleanTypes = totalCleanTypes.filter(
    ({ label }) => cleaningRequestCategoryToLabel[label],
  );

  const formattedDate = momentTz
    .tz(startAt, timezone)
    .calendar(momentTz.tz(timezone), {
      sameDay: "[Today]",
      nextDay: "[Tomorrow]",
      lastDay: "[Yesterday]",
      nextWeek: "MMM D",
      lastWeek: "MMM D",
      sameElse: "MMM D",
    });

  return (
    <div>
      <Text>{formattedDate}</Text>

      <Grid>
        {filteredCleanTypes.map(({ value, label }) => {
          return (
            <ValueAndLabel key={label}>
              <Value>{value}</Value>
              <Label>{cleaningRequestCategoryToLabel[label]}</Label>
            </ValueAndLabel>
          );
        })}
      </Grid>
    </div>
  );
};
